module.exports = __webpack_public_path__ + "img/protective_gear2.d653f6a5.png";